import { gql } from "@apollo/client";


export const GET_NOTIFICATION_SETTINGS = gql`
query NotificationSettingsMany {
  settings: NotificationSettingsMany {
    userId
  }
}
`

export const SAVE_NOTIFICATION_SETTINGS = gql`
mutation Mutation($record: NotificationSettingsInput!) {
  NotificationSettingsSaveMany(record: $record)
}
`
